module.exports = __webpack_public_path__ + "img/newsgovhk-grey.d51d7f41.jpg";